import type { TFunction } from 'i18next'
import { COMPARISON_THRESHOLD } from '../NeighborhoodContextTab.constants'

export const useComparisonText = (t: TFunction) => {
  const getComparisonText = (value: number, avgValue: number) => {
    const diff = ((value - avgValue) / avgValue) * 100
    if (Math.abs(diff) < COMPARISON_THRESHOLD)
      return t('neighborhood.comparison.similar')
    if (diff > 0)
      return t('neighborhood.comparison.aboveAverage', {
        percent: Math.round(diff),
      })
    return t('neighborhood.comparison.belowAverage', {
      percent: Math.round(Math.abs(diff)),
    })
  }

  return { getComparisonText }
}
